// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CANCEL = "Zru\u0161";
export const MY_PRODUCTS_ADD = "Pridaj do profilu";
export const MY_PRODUCTS_EDIT = "Uprav";
export const MY_PRODUCTS_EDIT_CANCEL = "Hotovo";
export const MY_PRODUCTS_SELECT_ENTER_SOME_CHARS = "Zadaj aspo\u0148 2 znaky z n\u00e1zvu";
export const USER_STROLLERS_ADD_NEXT_STROLLER = "Pridaj \u010fal\u0161\u00ed ko\u010d\u00edk";
export const USER_STROLLERS_ADD_STROLLER = "Pridaj ko\u010d\u00edk";
export const USER_STROLLERS_SELECT_NO_RESULTS = "\u017diadny v\u00fdsledok";
